import { render, staticRenderFns } from "./CustomerPage.vue?vue&type=template&id=a5eb6378&scoped=true&"
import script from "./CustomerPage.vue?vue&type=script&lang=js&"
export * from "./CustomerPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPage.vue?vue&type=style&index=0&id=a5eb6378&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5eb6378",
  null
  
)

export default component.exports